import { AlertSeverity, ServiceCategory, ServiceSubcategory } from '@commenda/prisma';

export { AlertSeverity };

export const AlertStatus = {
  SCHEDULED: 'SCHEDULED',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  DISABLED: 'DISABLED',
} as const;

export type AlertStatus = (typeof AlertStatus)[keyof typeof AlertStatus];

export type TServiceAlertCreatedBy = {
  id: string | null;
  name: string | null;
  email: string | null;
};

export type TServiceAlert = {
  id: string;
  title: string | null;
  description: string;
  link: string | null;
  severity: AlertSeverity;
  serviceCategory: ServiceCategory | null;
  serviceSubcategory: ServiceSubcategory | null;
  serviceCompositeIds: string[];
  startDate: string;
  endDate: string | null;
  enabled: boolean;
  createdBy: TServiceAlertCreatedBy | null;
  createdAt: string;
  updatedAt: string;
};

export type TServiceAlertListItem = TServiceAlert & {
  status: AlertStatus;
  reach: number;
};

export type TActiveServiceAlert = Pick<
  TServiceAlert,
  'id' | 'title' | 'description' | 'link' | 'severity'
>;

export type TServiceAlertListResponse = {
  alerts: TServiceAlertListItem[];
  count: number;
};

export type TActiveServiceAlertResponse = {
  alerts: TActiveServiceAlert[];
  count: number;
};

export type TPreviewReachResponse = {
  count: number;
};

export type TCreateServiceAlertParams = {
  title?: string;
  description: string;
  link?: string;
  severity: AlertSeverity;
  serviceCategory?: ServiceCategory;
  serviceSubcategory?: ServiceSubcategory;
  serviceCompositeIds?: string[];
  startDate: string;
  endDate?: string;
  enabled?: boolean;
};

export type TActiveServiceAlertsParams = {
  serviceCompositeId?: string | null;
};

export type TPreviewReachParams = {
  serviceCategory?: ServiceCategory | null;
  serviceSubcategory?: ServiceSubcategory | null;
  serviceCompositeIds?: string[];
};
